/* @ngInject */
const myContactsDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myContacts: '=',
    },
    template: require('./myContactsDisplay.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myContactsDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/directives/display/myContactsDisplay.js